import { useState, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { setUser } from "../store/usersSlice";
import { useAppDispatch } from "../store";

function useAccessToken(envConfig) {
    const { instance, accounts } = useMsal();
    const [accessToken, setAccessToken] = useState(null);
    const dispatch = useAppDispatch();

    useEffect(() => {
      if (!envConfig) return;

      if (accounts.length > 0) {
          const request = {
              scopes: [envConfig.auth.scope],
              account: accounts[0]
          };
          dispatch(setUser(accounts[0].username));
          instance.acquireTokenSilent(request).then(response => {
              setAccessToken(response.accessToken);
          }).catch(error => {
              // acquireTokenSilent can fail for a number of reasons, fallback to interaction
              if (error instanceof InteractionRequiredAuthError) {
                  instance.acquireTokenRedirect(request).then(response => {
                  });
              }
          });
      }
    }, [envConfig, accounts, instance, dispatch]);

    return accessToken;
}

export default useAccessToken;